import React from 'react';
import { TeamDeliverablesCard as TeamDeliverablesCardType } from '../../../../services/about-us/fetchAboutUsPageContent';
import styled from 'styled-components';
import { Text } from '../../../../components';
import { CardTitle } from '../../../../components/CardTitle/CardTitle';
import { COLORS, device } from '../../../../constants';
import { SHADOW } from '../../../../constants/animations';
import { MotionGridBlock } from '../../../../components/Motion';

interface TeamDeliverablesCardProps {
  card: TeamDeliverablesCardType;
  icon: React.FC;
}

const TeamDeliverablesCard = ({
  card,
  icon: Icon,
}: TeamDeliverablesCardProps) => {
  return (
    <TeamDeliverablesCardWrapper>
      <Icon />
      <CardTitle weight={600} title={card.Name} />
      <Text size={16} lineHeight={24} text={card.Description} />
    </TeamDeliverablesCardWrapper>
  );
};
const TeamDeliverablesCardWrapper = styled(MotionGridBlock)`
  display: flex;
  background-color: ${COLORS.WHITE};
  flex-direction: column;
  gap: 40px;
  box-sizing: border-box;
  min-height: 408px;
  padding: 40px;
  svg {
    width: 40px;
    height: 40px;
  }
  &:hover {
    background: ${COLORS.GRAY_BG_COLOR};
    box-shadow: ${SHADOW.HOVER.SERVICE_CARD};
  }
  @media screen and ${device.xl} {
    h3 {
      min-height: 72px;
    }
  }
  @media screen and ${device.lg} {
    padding: 30px;
    gap: 20px;
    min-height: 350px;
  }
  @media screen and ${device.md} {
    padding: 20px;
    min-height: 300px;
    h3 {
      min-height: 0;
    }
  }
  @media screen and ${device.bsm} {
    h3 {
      min-height: 60px;
    }
  }
  @media screen and ${device.sm} {
    svg {
      width: 25px;
      height: 25px;
    }
    h3 {
      min-height: 42px;
    }
    padding: 10px;
    gap: 10px;
    h4 {
      font-size: 13px;
      line-height: 1.5;
    }
    min-height: auto;
  }
`;
export { TeamDeliverablesCard };
